export default __webpack_public_path__ + "static/media/Poppins-Bold.300a4da5.ttf";